import styles from "./MypageInput.module.scss";
import { validateRequired } from "../../utils/validate";

const MypageRadioField = ({
  name,
  label,
  elements,
  register,
  validation = {},
  errors,
  watch,
  required = false,
  isStatic = false,
  readOnly = false,
  selectedValue,
  setSelectedValue,
}) => {
  const selectedText = elements.find((el) => {
    return String(el.value) === String(watch(name));
  });

  const handleChange = (e) => {
    const elm = elements.find((el) => {
      return e.target.value === String(el.value);
    });
    if (setSelectedValue) setSelectedValue(elm.value);
  };

  /**** バリデーションルール設定 ****/
  // 項目ごとのルール
  let rd_validation = validation;
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    rd_validation = { ...rd_validation, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={styles.mypageform__ttl}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__field} ${isStatic ? "d-none" : ""} ${
          errors[name] ? "is-invalid" : ""
        } ms-4`}
      >
        {/* ラジオボタンここから */}
        {elements.map((el, index) => (
          <div key={index}>
            <label className="mb-3">
              <input
                type="radio"
                name={name}
                className="form-check-input me-2"
                value={String(el.value)}
                defaultChecked={el.defaultChecked}
                {...register(name, { rd_validation, onChange: handleChange })}
                readOnly={isStatic || readOnly}
              />
              {el.text}
            </label>
          </div>
        ))}
        {/* ラジオボタンここまで */}
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {isStatic && (
        <div className={`${styles.mypageform__label} ps-4`}>
          {selectedText?.text}
        </div>
      )}
    </div>
  );
};

export default MypageRadioField;
